import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import styles from './ArchiveDetail.module.scss'
import UniversityArchive from './components/UniversityArchive'
import StudentArchive from './components/StudentArchive'
import EmployeeArchive from './components/EmployeeArchive'
import { Button, Layout } from "components/index";
import { getActivityLog } from 'service/ArchiveService'
import { ScaleLoader } from 'react-spinners'

function ActivityLog() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => {
    loadLogs()
  }, [filter])

  const loadLogs = async () => {
    try {
      setLoading(true)
      const archiveType = filter === 'all' ? null : filter
      const data = await getActivityLog(archiveType)
      setLogs(data)
    } catch (error) {
      console.error('Ошибка при загрузке журнала:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className={styles.loading_container}>
        <ScaleLoader color="#FF6B35" />
      </div>
    )
  }

  return (
    <div className={styles.activity_log}>
      <div className={styles.log_header_bar}>
        <h2>Журнал действий архивной системы</h2>
      </div>
      <div className={styles.filter_bar}>
        {[
          { key: 'all', label: 'Все записи' },
          { key: 'university', label: 'Университет' },
          { key: 'student', label: 'Студенты' },
          { key: 'employee', label: 'Сотрудники' },
        ].map(f => (
          <button
            key={f.key}
            className={`${styles.btn_filter} ${filter === f.key ? styles.active : ''}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>
      <div className={styles.log_entries}>
        {logs.length > 0 ? (
          logs.map((log) => (
            <div key={log.id} className={styles.log_entry}>
              <div className={styles.log_entry_header}>
                <div className={styles.log_action_label}>
                  <span className={styles.log_type_badge}>{log.archive_type}</span>
                  {log.action_type}
                </div>
                <span className={styles.log_time}>
                  {new Date(log.timestamp).toLocaleString('ru-RU')}
                </span>
              </div>
              <div className={styles.log_details}>
                {log.entity_name && <p><strong>Объект:</strong> {log.entity_name}</p>}
                {log.description && <p>{log.description}</p>}
                {log.employee && <p><strong>Пользователь:</strong> ID {log.employee}</p>}
                {log.ip_address && <p><strong>IP:</strong> {log.ip_address}</p>}
              </div>
            </div>
          ))
        ) : (
          <p className={styles.no_logs}>Записей не найдено</p>
        )}
      </div>
    </div>
  )
}

function ArchiveDetail() {
  const { archiveType } = useParams()
  const navigate = useNavigate()

  const archiveTitles = {
    university: 'Архив университета',
    students: 'Архив студентов',
    employees: 'Архив сотрудников',
    logs: 'Журнал действий',
  }

  const renderArchiveComponent = () => {
    switch (archiveType) {
      case 'university':
        return <UniversityArchive />
      case 'students':
        return <StudentArchive />
      case 'employees':
        return <EmployeeArchive />
      case 'logs':
        return <ActivityLog />
      default:
        return <div>Неизвестный тип архива</div>
    }
  }

  return (
    <Layout>
      <div className={styles.archive_detail}>
        <div className={styles.nav_header}>
          <button className={styles.btn_back} onClick={() => navigate('/archive/')}>
            ← Вернуться в архив
          </button>
          {archiveTitles[archiveType] && (
            <span style={{ fontFamily: 'Nunito, sans-serif', color: '#888', fontSize: '0.9rem' }}>
              {archiveTitles[archiveType]}
            </span>
          )}
        </div>
        {renderArchiveComponent()}
      </div>
    </Layout>
  )
}

export default ArchiveDetail

